
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/search",
      function () {
        return require("private-next-pages/ai/search/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/search"])
      });
    }
  